import Vue from 'vue';
import Element from 'element-ui';
import '../assets/css/element-variables.scss';

Vue.use(Element);
